type ResourcesLocale = typeof import('../en/resources').default

const resources = {
	types: {
		video: 'Vídeos',
		book: 'Libros',
		pdf: 'PDFs',
		post: 'Posts',
		image: 'Imágenes',
		link: 'Enlaces externos',
		file: 'Archivos',
	},
	emptyState: {
		title: 'Aún no hay recursos en este tema',
		body: 'Reúne vídeos, artículos y referencias para ampliar lo que estás estudiando.',
		collectCta: 'Recopilar recursos',
	},
	viewer: {
		navigation: {
			label: 'Recursos del tema',
			previous: 'Recurso anterior',
			next: 'Recurso siguiente',
			position: '{{current}} de {{total}}',
		},
		onThisPage: 'En esta página',
		backToTopic: 'Volver al tema',
		extractionFailed: {
			title: 'No pudimos extraer el contenido',
			description: 'Visita la página original para ver el contenido completo.',
		},
		openOriginal: 'Abrir original',
		pdf: {
			missingUrlTitle: 'PDF no disponible',
			missingUrlDescription:
				'No encontramos una URL de PDF válida para este recurso.',
		},
		savedContent: {
			saveAction: 'Guardar contenido',
			saveFailed:
				'No pudimos guardar este contenido. Reintenta o abre el original.',
			notSavedTitle: 'Guárdalo para leerlo aquí',
			notSavedDescription:
				'Usa el marcador para guardar este post en tu biblioteca y consultarlo de forma centralizada.',
			saving: 'Guardando contenido en tu biblioteca...',
			failedTitle: 'Contenido guardado como enlace',
			failedDescription:
				'No pudimos preparar la lectura offline de este post. Puedes abrir el original o volver a intentarlo.',
			retry: 'Reintentar',
		},
	},
	images: {
		title: 'Imágenes',
		titleWithTopic: 'Imágenes · {{topicName}}',
		viewerTitle: 'Imágenes · {{resourceTitle}}',
		dialogTitle: 'Imágenes de {{topicName}}',
		dialogDescription:
			'Imagen {{current}} de {{total}}. Usa las flechas para navegar.',
		counter: 'Imagen {{current}} de {{total}}',
		single: 'Imagen',
		imageSingular: 'imagen',
		imagePlural: 'imágenes',
		more: 'más',
		untitled: 'Sin título',
		source: 'Fuente',
		viewOriginal: 'Ver original',
		deleteTitle: '¿Eliminar imagen?',
		deleteDescription:
			'Esta acción no se puede deshacer. La imagen se eliminará permanentemente.',
		noImages: 'No hay imágenes en este recurso',
		addImagesMessage: 'Las imágenes aparecerán aquí cuando se añadan.',
	},
	operations: {
		resourceTypeTitle: {
			text: 'Texto',
			post: 'Post/Artículo',
			pdf: 'PDF',
			video: 'Vídeo',
			quiz: 'Cuestionario',
			api: 'API',
			unknown: '{{type}}',
		},
		summary: {
			noContent: 'Sin contenido',
			text: '{{summary}}',
			post: '{{summary}}',
			externalUrl: 'URL externa: {{url}}',
			videoFromSource: 'Vídeo de {{source}}: {{videoUrl}}',
			quizQuestions_one: 'Cuestionario con {{count}} pregunta',
			quizQuestions_other: 'Cuestionario con {{count}} preguntas',
			apiEndpoint: 'API {{method}} {{endpoint}}',
			typeFallback: 'Recurso de tipo {{type}}',
			error: 'Error al obtener información del recurso',
		},
	},
} satisfies ResourcesLocale

export default resources
